import React from 'react';
import moment from 'moment';
import { defineMessages, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

const lastUpdatedData = defineMessages({
  oneDay: {
    id: 'shared_component.calendar.last_updated.one_day',
    defaultMessage: 'Updated 1 day ago'
  },
  anyDays: {
    id: 'shared_component.calendar.last_updated.any_days',
    defaultMessage: 'Updated {days} days ago'
  },
  oneWeek: {
    id: 'shared_component.calendar.last_updated.any_week',
    defaultMessage: 'Updated 1 week ago'
  },
  anyWeeks: {
    id: 'shared_component.calendar.last_updated.any_weeks',
    defaultMessage: 'Updated {weeks} weeks ago'
  },
  moreThenMonth: {
    id: 'shared_component.calendar.last_updated.more_then_month',
    defaultMessage: 'Updated more than 4 weeks ago'
  }
});

const LastUpdated = ({ lastUpdatedDate }) => {
  const hoursToNow = moment().diff(lastUpdatedDate, 'hours');

  if (24 > hoursToNow) {
    return <FormattedMessage { ...lastUpdatedData.oneDay } />;
  }
  if (168 > hoursToNow) {
    return <FormattedMessage { ...lastUpdatedData.anyDays } values={{ days: Math.ceil(hoursToNow / 24) }} />;
  }
  if (336 > hoursToNow) {
    return <FormattedMessage { ...lastUpdatedData.oneWeek } />;
  }
  if (672 > hoursToNow) {
    return <FormattedMessage { ...lastUpdatedData.anyWeeks } values={{ weeks: Math.floor(hoursToNow / 24 / 7) }} />;
  }
  return <FormattedMessage { ...lastUpdatedData.moreThenMonth } />;
};

LastUpdated.propTypes = {
  lastUpdatedDate: PropTypes.string.isRequired
};

export default LastUpdated;
